export class Error {
    key: string;

    constructor(key: string) {
        this.key = key;
    }
}
  